/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, type Rest, HttpService } from '@dm/core';
import { type ServiceAd } from 'app/common/types/mo';
import { type Observable } from 'rxjs';

import { MO } from '../../../../../common/constants';
import { DomainStatusE } from './service-ad-str.service';

@Injectable({ providedIn: 'root' })
export class ServiceAdService {
    constructor(
        private http: HttpService,
    ) {}

    /**
     * 查询AD域设置rest
     */
    getAdRest(): Rest {
        return this.http.makeUrl('serviceAd.get');
    }

    /**
     * 查询AD域设置
     */
    get(vstoreId: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('serviceAd.get');
        rest.setParams({
            vstoreId,
        });
        return this.http.get(rest, options);
    }

    /**
     * 修改AD域设置
     */
    modify(vstoreId: string, data: ServiceAd, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('serviceAd.put');
        const params: ServiceAd = {
            ...data,
            vstoreId,
        };
        return this.http.put(rest, params, options);
    }

    /**
     * 加入域
     */
    joinDomain(vstoreId: string, data: ServiceAd, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('serviceAd.joinDomain');
        const params: ServiceAd = {
            ...data,
            vstoreId,
            DOMAINSTATUS: DomainStatusE.Join,
            TYPE: MO.AD_CONFIG,
        };
        return this.http.put(rest, params, options);
    }

    /**
     * 退出域
     */
    logoutDomain(vstoreId: string, data: ServiceAd, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('serviceAd.logoutDomain');
        const params: ServiceAd = {
            ...data,
            vstoreId,
            DOMAINSTATUS: DomainStatusE.Logout,
            TYPE: MO.AD_CONFIG,
        };
        return this.http.put(rest, params, options);
    }

    /**
     * 测试AD全域名
     */
    test(vstoreId: string, FULLDOMAINNAME: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('serviceAd.test');
        const params: ServiceAd = {
            vstoreId,
            FULLDOMAINNAME,
        };
        return this.http.put(rest, params, options);
    }
}
